import { getColor, Label, LabelProps, styled } from 'imaginarity-react-ui';
import * as React from 'react';
import * as _ from "lodash";
import { columnActionWidth, columnFlagWidth } from './Editors/EditorsSC';
import MissingInputHint from 'components/MissingInput/MissingInputHint';
import LabelInfo from 'components/LabelInfo';

interface LabelAndEditor {
    label: LabelProps;
    renderMissing?: JSX.Element;
    editor: JSX.Element;
    height?: string;
    labelInfo?: string;
    missingInfo?: string;
}

interface EditPartLabelAndEditorProps {
    children: LabelAndEditor[];
    labelPaddingRight?: number;
}
const gridWith = columnActionWidth + columnFlagWidth;
const gridWithEdit = columnFlagWidth;
export const EPLContainer = styled.div<{ minimized?: boolean }>`
    display: grid;
    grid-template-columns: ${p => p.minimized ? "1fr" : gridWith + "px"} 1fr;   
    button>div{margin:0;}
`;
export const EPLContainerEdit = styled.div<{ minimized?: boolean }>`
    display: grid;
    grid-template-columns: ${p => p.minimized ? "1fr" : gridWithEdit + "px"} 1fr;   
`;

export const EPLLabelContainer = styled.div<{ height?: string }>`
    padding-left: 5px;
    padding-top: 10px;
    height: ${p => p.height ?? "45px"};
`;

export const EPLEditContainer = styled.div<{ bordered?: boolean }>`
    border: ${p => p.bordered ? `1px solid ${getColor(p, p.theme.colors.middleLightGrey)}` : "none"};
    padding-top: ${p => p.bordered ? "10px" : 0};
    padding-left: ${p => p.bordered ? "10px" : 0};
    padding-right: ${p => p.bordered ? "10px" : 0};
    margin-top: ${p => p.bordered ? "5px" : 0};
`;
export const EPLEditContainerTextAreaInput = styled.div`
    .ql-editor{
        resize: none !important;
        height: 40px !important;
        min-height: unset !important;
        line-height: 20px !important;
        padding: 10px 15px !important;
        overflow: hidden !important;
        //white-space: nowrap !important;
    }
`;

const EditPartLabelAndEditor = (p: EditPartLabelAndEditorProps) => {
    const { children, labelPaddingRight } = p;
    return (
        <EPLContainer>
            {_.map(children, c => (
                <React.Fragment key={`${c.label.content}-${c.label.icon}`}>
                    <EPLLabelContainer height={c.height} style={{ paddingRight: labelPaddingRight }}>
                        <Label {...c.label} />
                        {c.labelInfo !== undefined &&
                            <LabelInfo infoText={c.labelInfo ?? ""} />
                        }
                        {c.missingInfo !== undefined &&
                            <MissingInputHint tooltipErrorText={c.missingInfo} />
                        }
                        {c.renderMissing}
                    </EPLLabelContainer>
                    <EPLEditContainer>
                        {c.editor}
                    </EPLEditContainer>
                </React.Fragment>
            ))}
        </EPLContainer>
    );
}
export default EditPartLabelAndEditor;